<template>
    <div v-if="showPage" class="my-projects">
        <div class="box-wrap">
            <div class="action-box">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/initial-quote.png" alt="Modernization">
                    </div>
                    <h3>Modernization</h3>
                    <router-link to="/modernization" class="btn-box" style="background: #00b050;">Go</router-link>
                </div>
            </div>

            <div class="action-box box-sep"><div class="box-content">&nbsp;</div></div>

            <div class="action-box">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/final-proposal.png" alt="Construction">
                    </div>
                    <h3>Construction</h3>
                    <router-link to="/construction" class="btn-box" style="background: #00b050;">Go</router-link>
                </div>
            </div>
        </div>
        <div class="box-wrap">
            <div class="action-box" v-if="user.role !== 'super-user'">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/components.png" alt="Parts and Tools">
                    </div>
                    <h3>Parts and Tools</h3>
                    <router-link to="/spare-parts" class="btn-box" style="background: #00b050;">Go</router-link>
                </div>
            </div>

            <div class="action-box box-sep"><div class="box-content">&nbsp;</div></div>

            <div class="action-box">
                <div class="box-content">
                    <div class="box-content-image">
                        <img src="https://torindrivena.com/wp-content/themes/torindriveintl/images/spare-parts.png" alt="Support">
                    </div>
                    <h3>Support</h3>
                    <router-link to="/support" class="btn-box" style="background: #00b050;">Go</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'tables',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        user : {},
        showPage: false
      }
    },
    beforeMount(){
      if (localStorage.getItem('user') && localStorage.getItem('need_reset') === '1') {
        this.$router.push('/reset').catch(() => {});
      } else {
        const user = localStorage.getItem('user');
        if ( !user ) this.$router.push('login');
        this.user = JSON.parse(user);
        if (this.user.role === 'project-manager' || this.user.role === 'super_admin' || this.user.role === 'administrator') {
          this.$router.push('projects');
        } else {
          this.showPage = true;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
.box-wrap {
    margin-left: 89px;
    &:first-child {
        margin-top: 32px;
    }
    &:nth-child(2) {
        margin-top: 48px;
    }
}
@media (max-width: 992px) {
    .box-wrap {
        max-width: 542px;
        &:first-child {
            margin: 16px auto;
        }
        &:nth-child(2) {
            margin: 32px auto;
        }
        .action-box {
            &.box-sep {
                width: 48px;
            }
        }
    }
}
@media (max-width: 560px) {
    .action-box {
        height: 160px;
        .box-content {
            h3 {
                font-size: 12px;
            }
        }
    }
}
</style>

